const url =" https://soccadmin.onrender.com/api/"
// const url = 'http://localhost:1507/api/'
// const url=''
// added now
export default url